export const comments_5089930 = {"data":{"data":[],"links":{}}}